module.exports = __webpack_public_path__ + "img/HQ-OA-360V03NU_ALL.4f61e595.jpg";